import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, MessageSquare } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  });
  const [Loader, setLoader] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true)
    const form = e.target;
    
    let obj = {
      name: form.name.value,
      email: form.email.value,
      company: form.company.value,
      phone: form.phone.value,
      service: form.service.value,
      message: form.message.value
    };

    const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbydoLCSyDsUz5xLCRiQqBggbRuW3CdxUAgR4zcDQiHAnYbcQwp1Mg-PgoPkXHdlrtsO/exec";
  
    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors', 
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
      });

    // alert('Thank you for your message! We will get back to you soon.');
      alert("Form submitted! We will get back to you soon.");
      form.reset(); 
      setLoader(false)
      setFormData({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  })
    } catch (error) {
      console.error("Error!", error.message);
      alert("Something went wrong.");
      setLoader(false)
            setFormData({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  })
    }
};


  const contactInfo = [
    {
      icon: Mail,
      label: 'Email',
      value: 'contact@howztech.com',
      link: 'mailto:contact@howztech.com'
    },
    {
      icon: Phone,
      label: 'Phone',
      value: '+91 7987842694',
      link: 'tel:+917987842694'
    },
    {
      icon: MapPin,
      label: 'Location',
      value: 'Bhopal Madhya Pradesh, 462038',
      link: null
    }
  ];

  const services = [
    'Web Development',
    'Mobile App Development',
    'AI & Automation',
    'Software & ERP',
    'Branding & UI/UX',
    'Cloud Solutions',
    'Other'
  ];

  return (
    <section id="contact" className="relative py-32 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="w-full h-full"
          style={{
            backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(255,255,255,0.1) 1px, transparent calc(7.6923% + 1px)),
                             repeating-linear-gradient(-90deg, #fff, #fff 1px, transparent 1px, transparent 7.6923%)`
          }}
        />
      </div>

      {/* Glowing Orbs */}
      <div className="absolute top-20 left-20 w-96 h-96 bg-[#00FFD1]/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#00FFD1]/10 rounded-full blur-[120px]" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <motion.span
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="inline-block text-[#00FFD1] text-lg font-medium mb-4 tracking-wide"
          >
            GET IN TOUCH
          </motion.span>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Let's Build Something <span className="text-[#00FFD1]">Amazing</span>
          </h2>
          <p className="text-xl text-white/85 max-w-3xl mx-auto leading-relaxed">
            Ready to transform your digital presence? Partner with us today.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-2"
          >
            <h3 className="text-3xl font-bold text-white mb-8">
              Contact Information
            </h3>
            
            <div className="space-y-6 mb-12">
              {contactInfo.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    className="flex items-start gap-4 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-[#00FFD1]/10 flex items-center justify-center transition-all duration-400 group-hover:bg-[#00FFD1]/20">
                      <IconComponent className="text-[#00FFD1]" size={24} strokeWidth={1.5} />
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{item.label}</p>
                      {item.link ? (
                        <a
                          href={item.link}
                          className="text-white text-lg hover:text-[#00FFD1] transition-colors duration-300"
                        >
                          {item.value}
                        </a>
                      ) : (
                        <p className="text-white text-lg">{item.value}</p>
                      )}
                    </div>
                  </motion.div>
                );
              })}
            </div>

            {/* WhatsApp Button */}
            <motion.a
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              href="https://wa.me/7987842694"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 text-lg font-medium transition-all duration-400 hover:shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:scale-105"
            >
              <MessageSquare size={24} />
              Chat on WhatsApp
            </motion.a>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-3"
          >
            <form onSubmit={handleSubmit} className="bg-[#121212] border border-white/25 p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">

                {/* ----------------- Name *------------------- */}
                <div>
                  <label htmlFor="name" className="block text-white mb-2 text-sm font-medium">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full bg-black border border-white/25 text-white px-4 py-3 focus:outline-none focus:border-[#00FFD1] transition-colors duration-300"
                    placeholder="John Doe"
                  />
                </div>

                {/* ----------------- Email * ------------------- */}
                <div>
                  <label htmlFor="email" className="block text-white mb-2 text-sm font-medium">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full bg-black border border-white/25 text-white px-4 py-3 focus:outline-none focus:border-[#00FFD1] transition-colors duration-300"
                    placeholder="john@example.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">

                {/* --------------- Company ------------------- */}
                <div>
                  <label htmlFor="company" className="block text-white mb-2 text-sm font-medium">
                    Company
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full bg-black border border-white/25 text-white px-4 py-3 focus:outline-none focus:border-[#00FFD1] transition-colors duration-300"
                    placeholder="Your Company"
                  />
                </div>


                {/* ----------------- Phone Number ------------------- */}
                <div>
                  <label htmlFor="phone" className="block text-white mb-2 text-sm font-medium">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full bg-black border border-white/25 text-white px-4 py-3 focus:outline-none focus:border-[#00FFD1] transition-colors duration-300"
                    placeholder="+1 (555) 000-0000"
                  />
                </div>
              </div>

              {/* ------------------- Service Interested In * ----------------- */}
              <div className="mb-6">
                <label htmlFor="service" className="block text-white mb-2 text-sm font-medium">
                  Service Interested In *
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                  className="w-full bg-black border border-white/25 text-white px-4 py-3 focus:outline-none focus:border-[#00FFD1] transition-colors duration-300"
                >
                  <option value="">Select a service</option>
                  {services.map((service, index) => (
                    <option key={index} value={service}>
                      {service}
                    </option>
                  ))}
                </select>
              </div>



                {/* ----------------- Your Message * ------------------- */}
              <div className="mb-6">
                <label htmlFor="message" className="block text-white mb-2 text-sm font-medium">
                  Your Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full bg-black border border-white/25 text-white px-4 py-3 focus:outline-none focus:border-[#00FFD1] transition-colors duration-300 resize-none"
                  placeholder="Tell us about your project..."
                />
              </div>



                {/* ----------------- Submit Button ------------------- */}

                {Loader == false? 
              <button
                type="submit"
                className="group w-full bg-[#00FFD1] text-black px-8 py-4 text-lg font-medium transition-all duration-400 hover:bg-white hover:shadow-[0_0_30px_rgba(0,255,209,0.4)] flex items-center justify-center gap-3"
              >
                Send Message
                <Send className="transition-transform duration-300 group-hover:translate-x-1" size={20} />
              </button>
              :
              <div
                className="group w-full bg-[#00FFD1] opacity-50 text-black px-8 py-4 text-lg font-medium transition-all duration-400 flex items-center justify-center gap-3"
              >
                Loading ...
              </div>
                }

            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
